import { Component, OnInit } from '@angular/core';
import {Message,MessageService, SelectItem} from 'primeng/api';

import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from 'src/app/Services/rest-api-service';
import { environment } from '../../../environments/environment';
import { AppListResponse } from 'src/app/Model/apilistresponse-model';
import { App, SmartApp } from 'src/app/Model/app-model';
import { Subscription, SubscriptionList } from 'src/app/Model/product-model';


@Component({
  selector: 'raise-request',
  templateUrl: './raise-request.component.html',
  
})
export class RaiseRequest implements OnInit {




  
   status;
   autoApprovalMsg=false;

  constructor(private route: ActivatedRoute,private router: Router,private restApi: RestApiService) {
                  this.route.params.subscribe(params => {
                      this.status=params['status'];

                      if(this.status=='new'){
                        this.raiseTheRequestNow();
                      }

                      if(this.status=='already-raised'){
                       
                        this.router.navigate(['subscriptionstatus']);
                      }
                  })
    }

  ngOnInit(): void {
  
  
  }

  
   goBackToApps(){

    this.router.navigate(['myapp']);
   }


   appType;
   regionLabel;
  roleLabelForEmail;
      sendEmailToBuinessForProdtoSandboxMove(){

        this.regionLabel = environment.getEnvironment();

        console.log("sendEmailToBuinessForProdtoSandboxMove-------------------------------"+localStorage.getItem("email_display_app_name"))
        let htmlBodyB="<style>table, th, td {border: 1px solid black;border-collapse: collapse;}th, td {padding: 5px;}th {text-align: left;}</style><br><p>Dear Interoperability Team,<br/> <br/>The below Production approved user has created a Sandbox application and has been auto approved.<br> <br>Please use the below Quickbase link to update the record accordingly for Sandbox access.</p><table style='width:100%'><tr><th>Registrant Name</th><th>Registrant Email Address</th><th>Production Application Name(s)</th><th>Product(s) Subscribed</th></tr><tr><td>"+localStorage.getItem("firstName")+" "+localStorage.getItem("lastName")+"</td><td> <u>"+localStorage.getItem("email_ID")+"</u> </td><td>"+localStorage.getItem("email_display_app_name")+"</td><td>"+localStorage.getItem("email_display_sub_name")+"</td></tr></table><br>"+this.reportUrl+localStorage.getItem("email_ID");
        let toB=environment.getEmailDL();
        let fromB="APICDevportal@AETNA.com";
        let subjectB="Sandbox Access Auto Approved for "+this.roleLabelForEmail+"("+this.regionLabel+")";
        let request={from:fromB,to:toB,htmlBody:htmlBodyB,subject:subjectB,bcc:'NA',cc:'NA'};
          return this.restApi.emailTrigger(request).subscribe((data: {}) => {
           
          },(error)=>{
            
           //  console.log(error);
          })
    
      }


   raiseTheRequestNow(){

    let role=localStorage.getItem('roleValue');

    let env= localStorage.getItem('access_env');


    let upperValue='NA';
 
    let autoRequest;
    if(env=='sandbox' && role=='0'){

      this.appType='Developer';
      this.roleLabelForEmail='Third-Party';
      upperValue= localStorage.getItem("my_new_vet_pd");

      this.reportUrl=environment.dev_report_url();

      autoRequest={"forAccess":true,"env":env,'role':role,'sandboxDevAutoApproval':true };
      
    }
    if(env=='sandbox' && role=='1'){
              
      this.appType='Payer';
      this.roleLabelForEmail='Payer';
       upperValue  =localStorage.getItem("my_new_vet_pp");
       this.reportUrl=environment.payer_report_url();

       autoRequest={"forAccess":true,"env":env,'role':role,'sandboxPayerAutoApproval':true };
    
    }


    if(env=='sandbox' && role=='2'){
              
      this.appType='Broker';

      this.roleLabelForEmail='Broker';
      upperValue  =localStorage.getItem("my_new_vet_pb");

      this.reportUrl=environment.broker_report_url();
      autoRequest={"forAccess":true,"env":env,'role':role,'sandboxPayerAutoApproval':true };
   
   }



   if(env=='sandbox' && role=='3'){
              
    this.appType='Provider';
    this.roleLabelForEmail='Provider EHR';
    upperValue  =localStorage.getItem("my_new_vet_ppd");
    this.reportUrl=environment.provider_report_url();
    autoRequest={"forAccess":true,"env":env,'role':role,'providerAutoApproval':true };
 
 }



    if(upperValue=='A'){

      this.loadAppList(role);
      this.raiseRequestForAutoApproval(autoRequest);
     // this.sendEmailToBuinessForProdtoSandboxMove();
      return true;
    }
   
    const requestJSON={"forAccess":true,"env":env,'role':role };
    //console.log(requestJSON);
     this.restApi.createApp_PostRequest(requestJSON).subscribe(
      (data:any) =>
        
      { 


        if(env=="sandbox" && role=="0") {
				
    
          localStorage.setItem("my_new_vet_sd",'P');
        
			
         
          
       }
       
       if(env=="sandbox" && role=="1") {
         
      
        localStorage.setItem("my_new_vet_sp",'P');
       

       }
       
       if(env=="production" && role=="0") {
         
      
        localStorage.setItem("my_new_vet_pd",'P');
      
        
       }
       
       if(env=="production" && role=="1") {
         
      
        localStorage.setItem("my_new_vet_pp",'P');
       }
       
       
     //changes for broker role


     if(env=="sandbox" && role=="2") {
         
      
      localStorage.setItem("my_new_vet_sb",'P');
     

     }


     if(env=="production" && role=="2") {
         
      
      localStorage.setItem("my_new_vet_pb",'P');
     }


       //changes for provider role

     if(env=="sandbox" && role=="3") {
         
      
      localStorage.setItem("my_new_vet_spd",'P');
     

     }


     if(env=="production" && role=="3") {
         
      
      localStorage.setItem("my_new_vet_ppd",'P');
     }



       
        localStorage.setItem("single_email","1")
        this.router.navigate(['subscriptionstatus']);

       
    },
      (error) =>{
         }
      
      
    )


   


      }



    reportUrl;

      raiseRequestForAutoApproval(request){

        let role=localStorage.getItem('roleValue');

        let env= localStorage.getItem('access_env');

        this.restApi.createApp_PostRequest(request).subscribe(
          (data:any) =>
            
          { 
    

            if(env=="sandbox" && role=="0") {
				
    
              localStorage.setItem("my_new_vet_sd",'A');
            
          
           }
           
           if(env=="sandbox" && role=="1") {
             
          
            localStorage.setItem("my_new_vet_sp",'A');
           
    
           }


           if(env=="sandbox" && role=="2") {
             
          
            localStorage.setItem("my_new_vet_sb",'A');
           
    
           }


           if(env=="sandbox" && role=="3") {
             
          
            localStorage.setItem("my_new_vet_spd",'A');
           
    
           }


  
          this.autoApprovalMsg=true;
        },
          (error) =>{
             }
          
          
        )
    
             
      } // auto approval request


      appList;
    
      loadAppList(roleEmail) {
       localStorage.removeItem("email_display_app_name");
       localStorage.removeItem("email_display_sub_name");
        return this.restApi.getAppList().subscribe(async (data: {}) => {
         
          this.appList=data as AppListResponse;
         // console.log("App List"+this.appList.status); 
    
          for(let myapp of this.appList.appListView){
    
            console.log("my app env "+myapp.path)
            console.log("roleEmail "+roleEmail)
            
            if(myapp.path=='production'){
              localStorage.setItem("path","production");
              await this.loadSmartAppFlag(myapp,roleEmail);
              //await this.mySubscriptionForAnApp(myapp.appID);
            }
          }
    
       let emailApp=   localStorage.getItem("email_display_app_name");
       
        if(emailApp!=null){
            emailApp=this.removeLastComma(emailApp);
        }
       
       localStorage.setItem("email_display_app_name",emailApp);
       let emailSub=   localStorage.getItem("email_display_sub_name");
       if(emailSub!=null){
          emailSub=this.removeLastComma(emailSub);
       }
       localStorage.setItem("email_display_sub_name",emailSub);

          this.sendEmailToBuinessForProdtoSandboxMove();
        },(error)=>{
        })
      }
     

    removeLastComma(str){
      
    
      if (str.charAt(str.length - 1) === ',') {
        str = str.substring(0, str.length - 1);
      }

      return str;
    }

    
    async  loadSmartAppFlag(smartApp:App,roleEmail){
    
    
    
        let smartAppId=smartApp.appID;
    
        if(smartApp.legacyInd=='y'){
    
         smartAppId=smartApp.v5Id;
        }
    
    
       
    
         return this.restApi.getSmartAppFlag_promise(smartAppId).then(async (data: {}) => {
    
     //console.log("samrt app "+data.payerFlag)
     
    
       let  ResponseApp= data as SmartApp;
    
        smartApp.roleValue= ResponseApp.payerFlag;
    
        if(smartApp.roleValue==roleEmail){
        
          let appDisplay=localStorage.getItem("email_display_app_name");
          
           if(appDisplay==null){
            appDisplay=smartApp.appName+",";
           }else{
            appDisplay=appDisplay+smartApp.appName+",";
           }
        


          localStorage.setItem("email_display_app_name",appDisplay)

          await this.mySubscriptionForAnApp(smartApp.appID);
    
        }
    
    
       
    
    
         
    
    },(error)=>{
    
         
    
    })
    
    }
    subscriptionListForAnApp:SubscriptionList;
   subscriptionForAnApp:Subscription[];
   async mySubscriptionForAnApp(appID){
      // console.log("here we are")
     
     
      return this.restApi.mySubscriptionForAnApp_promise(appID).then((data: {}) => {
     
        this.subscriptionListForAnApp=data as SubscriptionList;
        this.subscriptionForAnApp=this.subscriptionListForAnApp.subsApiVO;
    
     
     
        for(const sub of this.subscriptionForAnApp){
           
          let subDisplay=localStorage.getItem("email_display_sub_name");
          
          if(subDisplay==null){
            subDisplay=sub.productName+",";
          }else{
            subDisplay=subDisplay+sub.productName+",";
          }
       


         localStorage.setItem("email_display_sub_name",subDisplay)

        
         }//end of for
  
       
      
       },(error)=>{
  
       })
     }

    }